import UserActionTypes from '../user/user-types'

import LedgerActionTypes from './ledger-types'

type TLedgerState = {
    defaultOperationalCurrency: any
    cards: any
    bankBic: any
    modalBankAccount: any
    loading: any
    loader: {
        FETCH_CURRENCIES_ID: any
        OPEN_BANK_ACCOUNTS_AVAILABLE: any
        USER_BANK_ACCOUNTS_ID: any
        COUNTRIES_LIST: any
        PAY_NOW: any
        GET_MAX_AMOUNT: any
        BANK_ACCOUNT_INTERNAL_TRANSFER: any
        BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: any
        BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: any
        TRANSFER_FROM_IBAN_TO_BANK: any
        FEE_CALCULATOR: any
        MERGED_FEE_CALCULATOR: any
        TRANSFER: any
        TRANSFER_TO_BANK: any
        EXCHANGE_All_ASSETS: any
        BANK_ACCOUNT_ORDER: any
        SECURE_3D_CARD: any
        SECURE_3D_ONLINE_BANK: any
        LEDGER_TOP_UP_WITH_NO_CARD_DATA: any
        LEDGER_TOP_UP_WITH_ONLINE_BANK: any
        ORDER_CURRENCY: any
        ORDER_MULTI_CURRENCY: any
        BANK_BIC: any
        COMPANY_PAYMENT_CARD: any
        SECURE_3D_COMPANY_CARD_PAYMENT: any
        COMPANY_PAYMENT_ONLINE_BANKING: any
        SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: any
        TRANSLITERATION_TRANSFER_REFERENCE: any
    }
    error: any
    success: any
    status: any
    successMsg: any
    successData: any
    successFeeData: any
    successMergedFeeData: any
    favouriteDashboardId: any
    countriesList: ICountriesList
    bankAccountsAvailable: any
    transliteratedReference: any
    modalAsset: any
    bankAccountsOpen: any
    selectedCurrency: IAvailableCurrencies
}

const INITIAL_STATE: TLedgerState = {
    defaultOperationalCurrency: null,
    cards: null,
    bankBic: null,
    modalBankAccount: null,
    loading: null,
    loader: null,
    error: null,
    success: null,
    status: null,
    successMsg: null,
    successData: null,
    successFeeData: null,
    successMergedFeeData: null,
    favouriteDashboardId: null,
    countriesList: null,
    bankAccountsAvailable: null,
    transliteratedReference: null,
    modalAsset: null,
    bankAccountsOpen: null,
    selectedCurrency: null,
}

const leaderReducer = (state = INITIAL_STATE, action): TLedgerState => {
    switch (action.type) {
        case LedgerActionTypes.START_FETCH_CURRENCIES_ID:
            return {
                ...state,
                loader: { ...state.loader, FETCH_CURRENCIES_ID: true },
            }
        case LedgerActionTypes.SUCCESS_FETCH_CURRENCIES_ID:
            return {
                ...state,
                modalAsset: action.payload,
                loader: { ...state.loader, FETCH_CURRENCIES_ID: null },
            }
        case LedgerActionTypes.START_OPEN_BANK_ACCOUNTS_AVAILABLE:
            return {
                ...state,
                loader: { ...state.loader, OPEN_BANK_ACCOUNTS_AVAILABLE: true },
            }
        case LedgerActionTypes.SUCCESS_OPEN_BANK_ACCOUNTS_AVAILABLE:
            return {
                ...state,
                bankAccountsOpen: action.payload,
                loader: { ...state.loader, OPEN_BANK_ACCOUNTS_AVAILABLE: null },
            }
        case LedgerActionTypes.START_USER_BANK_ACCOUNTS_ID:
            return {
                ...state,
                loader: { ...state.loader, USER_BANK_ACCOUNTS_ID: true },
                error: null,
            }
        case LedgerActionTypes.SUCCESS_USER_BANK_ACCOUNTS_ID:
            return {
                ...state,
                modalBankAccount: action.payload,
                loader: { ...state.loader, USER_BANK_ACCOUNTS_ID: null },
                error: null,
            }

        case LedgerActionTypes.START_COUNTRIES_LIST: {
            return {
                ...state,
                loader: { ...state.loader, COUNTRIES_LIST: true },
            }
        }
        case LedgerActionTypes.SUCCESS_COUNTRIES_LIST: {
            const countriesList = action.payload

            countriesList.unshift({ name: '', ccA2: '' })

            return {
                ...state,
                countriesList,
                loader: { ...state.loader, COUNTRIES_LIST: null },
                error: null,
            }
        }
        case LedgerActionTypes.FAILURE_COUNTRIES_LIST: {
            return {
                ...state,
                loader: { ...state.loader, COUNTRIES_LIST: null },
                error: true,
            }
        }

        case LedgerActionTypes.START_PAY_NOW:
            return {
                ...state,
                loader: { ...state.loader, PAY_NOW: true },
            }
        case LedgerActionTypes.SUCCESS_PAY_NOW:
            return {
                ...state,
                loader: { ...state.loader, PAY_NOW: null },
                success: { ...state.success, PAY_NOW: true },
                error: null,
            }
        case LedgerActionTypes.FINISH_PAY_NOW:
            return {
                ...state,
                loader: { ...state.loader, PAY_NOW: null },
                success: { ...state.success, PAY_NOW: null },
                error: null,
            }
        case LedgerActionTypes.FAILURE_PAY_NOW:
            return {
                ...state,
                loader: { ...state.loader, PAY_NOW: null },
                success: { ...state.success, PAY_NOW: null },
                error: true,
            }

        case LedgerActionTypes.START_GET_MAX_AMOUNT:
            return {
                ...state,
                loader: { ...state.loader, GET_MAX_AMOUNT: true },
            }
        case LedgerActionTypes.SUCCESS_GET_MAX_AMOUNT:
            return {
                ...state,
                successData: action.payload?.successData,
                loader: { ...state.loader, GET_MAX_AMOUNT: true }, // do not change to null - managed from MaxButton-component.tsx
                error: null,
            }
        case LedgerActionTypes.FINISH_GET_MAX_AMOUNT:
            return {
                ...state,
                successData: null,
                loader: { ...state.loader, GET_MAX_AMOUNT: null },
                error: null,
            }
        case LedgerActionTypes.FAILURE_GET_MAX_AMOUNT:
            return {
                ...state,
                successData: null,
                loader: { ...state.loader, GET_MAX_AMOUNT: null },
                error: true,
            }

        case LedgerActionTypes.START_BANK_ACCOUNT_INTERNAL_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_INTERNAL_TRANSFER: true },
            }
        case LedgerActionTypes.SUCCESS_BANK_ACCOUNT_INTERNAL_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_INTERNAL_TRANSFER: null },
                success: { ...state.success, BANK_ACCOUNT_INTERNAL_TRANSFER: true },
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_BANK_ACCOUNT_INTERNAL_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_INTERNAL_TRANSFER: null },
                success: { ...state.success, BANK_ACCOUNT_INTERNAL_TRANSFER: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_BANK_ACCOUNT_INTERNAL_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_INTERNAL_TRANSFER: null },
                success: { ...state.success, BANK_ACCOUNT_INTERNAL_TRANSFER: null },
                error: true,
            }

        case LedgerActionTypes.START_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: true },
            }
        case LedgerActionTypes.SUCCESS_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: null },
                success: { ...state.success, BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: true },
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: null },
                success: { ...state.success, BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: null },
                success: { ...state.success, BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY: null },
                error: true,
            }

        case LedgerActionTypes.START_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: true },
            }
        case LedgerActionTypes.SUCCESS_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: null },
                success: { ...state.success, BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: true },
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: null },
                success: { ...state.success, BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: null },
                success: { ...state.success, BANK_ACCOUNT_TOP_UP_WITH_CURRENCY: null },
                error: true,
            }

        case LedgerActionTypes.START_TRANSFER_FROM_IBAN_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_FROM_IBAN_TO_BANK: true },
            }
        case LedgerActionTypes.SUCCESS_TRANSFER_FROM_IBAN_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_FROM_IBAN_TO_BANK: null },
                success: { ...state.success, TRANSFER_FROM_IBAN_TO_BANK: true },
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_TRANSFER_FROM_IBAN_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_FROM_IBAN_TO_BANK: null },
                success: { ...state.success, TRANSFER_FROM_IBAN_TO_BANK: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_TRANSFER_FROM_IBAN_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_FROM_IBAN_TO_BANK: null },
                success: { ...state.success, TRANSFER_FROM_IBAN_TO_BANK: null },
                error: true,
            }

        case LedgerActionTypes.START_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, FEE_CALCULATOR: true },
            }
        case LedgerActionTypes.SUCCESS_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, FEE_CALCULATOR: null },
                successFeeData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, FEE_CALCULATOR: null },
                successFeeData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, FEE_CALCULATOR: null },
                successFeeData: null,
                error: true,
            }

        case LedgerActionTypes.START_MERGED_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, MERGED_FEE_CALCULATOR: true },
            }
        case LedgerActionTypes.SUCCESS_MERGED_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, MERGED_FEE_CALCULATOR: null },
                successMergedFeeData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_MERGED_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, MERGED_FEE_CALCULATOR: null },
                successMergedFeeData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_MERGED_FEE_CALCULATOR:
            return {
                ...state,
                loader: { ...state.loader, MERGED_FEE_CALCULATOR: null },
                successMergedFeeData: null,
                error: true,
            }

        case LedgerActionTypes.START_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER: true },
            }
        case LedgerActionTypes.SUCCESS_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER: null },
                success: { ...state.success, TRANSFER: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER: null },
                success: { ...state.success, TRANSFER: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_TRANSFER:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER: null },
                success: { ...state.success, TRANSFER: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.START_TRANSFER_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_TO_BANK: true },
            }
        case LedgerActionTypes.SUCCESS_TRANSFER_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_TO_BANK: null },
                success: { ...state.success, TRANSFER_TO_BANK: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_TRANSFER_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_TO_BANK: null },
                success: { ...state.success, TRANSFER_TO_BANK: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_TRANSFER_TO_BANK:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_TO_BANK: null },
                success: { ...state.success, TRANSFER_TO_BANK: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.START_TOP_UP_WITH_BANK_TRANSFER:
            return {
                ...state,
                loading: true,
            }

        case LedgerActionTypes.START_EXCHANGE_All_ASSETS:
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE_All_ASSETS: true },
            }
        case LedgerActionTypes.SUCCESS_EXCHANGE_All_ASSETS:
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE_All_ASSETS: null },
                success: { ...state.success, EXCHANGE_All_ASSETS: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_EXCHANGE_All_ASSETS:
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE_All_ASSETS: null },
                success: { ...state.success, EXCHANGE_All_ASSETS: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_EXCHANGE_All_ASSETS:
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE_All_ASSETS: null },
                success: { ...state.success, EXCHANGE_All_ASSETS: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.START_BANK_ACCOUNT_ORDER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_ORDER: true },
            }
        case LedgerActionTypes.SUCCESS_BANK_ACCOUNT_ORDER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_ORDER: null },
                success: { ...state.success, BANK_ACCOUNT_ORDER: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_BANK_ACCOUNT_ORDER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_ORDER: null },
                success: { ...state.success, BANK_ACCOUNT_ORDER: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_BANK_ACCOUNT_ORDER:
            return {
                ...state,
                loader: { ...state.loader, BANK_ACCOUNT_ORDER: null },
                success: { ...state.success, BANK_ACCOUNT_ORDER: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.START_SECURE_3D_CARD:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_CARD: true },
            }
        case LedgerActionTypes.SUCCESS_SECURE_3D_CARD:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_CARD: null },
                success: { ...state.success, SECURE_3D_CARD: true },
                status: action.payload?.status,
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_SECURE_3D_CARD:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_CARD: null },
                success: { ...state.success, SECURE_3D_CARD: null },
                successData: null,
                status: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_SECURE_3D_CARD:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_CARD: null },
                success: { ...state.success, SECURE_3D_CARD: null },
                successData: null,
                status: null,
                error: true,
            }

        case LedgerActionTypes.START_SECURE_3D_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_ONLINE_BANK: true },
            }
        case LedgerActionTypes.SUCCESS_SECURE_3D_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_ONLINE_BANK: null },
                success: { ...state.success, SECURE_3D_ONLINE_BANK: true },
                status: action.payload?.status,
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_SECURE_3D_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_ONLINE_BANK: null },
                success: { ...state.success, SECURE_3D_ONLINE_BANK: null },
                successData: null,
                status: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_SECURE_3D_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_ONLINE_BANK: null },
                success: { ...state.success, SECURE_3D_ONLINE_BANK: null },
                successData: null,
                status: null,
                error: true,
            }

        case LedgerActionTypes.START_LEDGER_TOP_UP_WITH_NO_CARD_DATA:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_NO_CARD_DATA: true },
            }
        case LedgerActionTypes.SUCCESS_LEDGER_TOP_UP_WITH_NO_CARD_DATA:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_NO_CARD_DATA: null },
                success: { ...state.success, LEDGER_TOP_UP_WITH_NO_CARD_DATA: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_LEDGER_TOP_UP_WITH_NO_CARD_DATA:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_NO_CARD_DATA: null },
                success: { ...state.success, LEDGER_TOP_UP_WITH_NO_CARD_DATA: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_LEDGER_TOP_UP_WITH_NO_CARD_DATA:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_NO_CARD_DATA: null },
                success: { ...state.success, LEDGER_TOP_UP_WITH_NO_CARD_DATA: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.START_LEDGER_TOP_UP_WITH_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_ONLINE_BANK: true },
            }
        case LedgerActionTypes.SUCCESS_LEDGER_TOP_UP_WITH_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_ONLINE_BANK: null },
                success: { ...state.success, LEDGER_TOP_UP_WITH_ONLINE_BANK: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_LEDGER_TOP_UP_WITH_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_ONLINE_BANK: null },
                success: { ...state.success, LEDGER_TOP_UP_WITH_ONLINE_BANK: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_LEDGER_TOP_UP_WITH_ONLINE_BANK:
            return {
                ...state,
                loader: { ...state.loader, LEDGER_TOP_UP_WITH_ONLINE_BANK: null },
                success: { ...state.success, LEDGER_TOP_UP_WITH_ONLINE_BANK: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.SUCCESS_TOP_UP_WITH_BANK_TRANSFER:
            return {
                ...state,
                error: null,
                loading: null,
                successMsg: true,
                successData: action.payload?.successData || null,
            }

        case LedgerActionTypes.START_ORDER_CURRENCY:
            return {
                ...state,
                error: null,
                successMsg: null,
                loader: { ...state.loader, ORDER_CURRENCY: true },
            }
        case LedgerActionTypes.SUCCESS_ORDER_CURRENCY:
            return {
                ...state,
                error: null,
                successMsg: true,
                loader: { ...state.loader, ORDER_CURRENCY: null },
            }
        case LedgerActionTypes.FINISH_ORDER_CURRENCY:
            return {
                ...state,
                error: null,
                successMsg: null,
                loader: { ...state.loader, ORDER_CURRENCY: null },
            }
        case LedgerActionTypes.FAILURE_ORDER_CURRENCY:
            return {
                ...state,
                error: true,
                successMsg: null,
                loader: { ...state.loader, ORDER_CURRENCY: null },
            }

        case LedgerActionTypes.START_ORDER_MULTI_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, ORDER_MULTI_CURRENCY: true },
            }
        case LedgerActionTypes.SUCCESS_ORDER_MULTI_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, ORDER_MULTI_CURRENCY: null },
                success: { ...state.success, ORDER_MULTI_CURRENCY: true },
                error: null,
            }
        case LedgerActionTypes.FINISH_ORDER_MULTI_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, ORDER_MULTI_CURRENCY: null },
                success: { ...state.success, ORDER_MULTI_CURRENCY: null },
                error: null,
            }
        case LedgerActionTypes.FAILURE_ORDER_MULTI_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, ORDER_MULTI_CURRENCY: null },
                success: { ...state.success, ORDER_MULTI_CURRENCY: null },
                error: true,
            }

        case LedgerActionTypes.START_BANK_BIC:
            return {
                ...state,
                loader: { ...state.loader, BANK_BIC: true },
            }
        case LedgerActionTypes.SUCCESS_BANK_BIC:
            return {
                ...state,
                loader: { ...state.loader, BANK_BIC: null },
                success: { ...state.success, BANK_BIC: true },
                bankBic: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_BANK_BIC:
            return {
                ...state,
                loader: { ...state.loader, BANK_BIC: null },
                success: { ...state.success, BANK_BIC: null },
                bankBic: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_BANK_BIC:
            return {
                ...state,
                loader: { ...state.loader, BANK_BIC: null },
                success: { ...state.success, BANK_BIC: null },
                bankBic: null,
                error: true,
            }

        case LedgerActionTypes.FINISH_TOP_UP_WITH_BANK_TRANSFER:
            return {
                ...state,
                successMsg: null,
                loading: null,
                error: null,
                successData: null,
            }

        case LedgerActionTypes.FAILURE_TOP_UP_WITH_BANK_TRANSFER:
            return {
                ...state,
                loading: null,
                successMsg: null,
                error: true,
            }

        case UserActionTypes.SIGN_IN_SUCCESS: {
            return {
                ...state,
                defaultOperationalCurrency: action.payload.defaultOperationalCurrency,
                selectedCurrency: action.payload.defaultOperationalCurrency,
            }
        }

        case LedgerActionTypes.START_COMPANY_PAYMENT_CARD:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_CARD: true },
            }
        case LedgerActionTypes.SUCCESS_COMPANY_PAYMENT_CARD:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_CARD: null },
                success: { ...state.success, COMPANY_PAYMENT_CARD: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_COMPANY_PAYMENT_CARD:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_CARD: null },
                success: { ...state.success, COMPANY_PAYMENT_CARD: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_COMPANY_PAYMENT_CARD:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_CARD: null },
                success: { ...state.success, COMPANY_PAYMENT_CARD: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.START_SECURE_3D_COMPANY_CARD_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_CARD_PAYMENT: true },
            }
        case LedgerActionTypes.SUCCESS_SECURE_3D_COMPANY_CARD_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_CARD_PAYMENT: null },
                success: { ...state.success, SECURE_3D_COMPANY_CARD_PAYMENT: true },
                status: action.payload?.status,
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_SECURE_3D_COMPANY_CARD_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_CARD_PAYMENT: null },
                success: { ...state.success, SECURE_3D_COMPANY_CARD_PAYMENT: null },
                successData: null,
                status: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_SECURE_3D_COMPANY_CARD_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_CARD_PAYMENT: null },
                success: { ...state.success, SECURE_3D_COMPANY_CARD_PAYMENT: null },
                successData: null,
                status: null,
                error: true,
            }

        case LedgerActionTypes.START_COMPANY_PAYMENT_ONLINE_BANKING:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_ONLINE_BANKING: true },
            }
        case LedgerActionTypes.SUCCESS_COMPANY_PAYMENT_ONLINE_BANKING:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_ONLINE_BANKING: null },
                success: { ...state.success, COMPANY_PAYMENT_ONLINE_BANKING: true },
                successData: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_COMPANY_PAYMENT_ONLINE_BANKING:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_ONLINE_BANKING: null },
                success: { ...state.success, COMPANY_PAYMENT_ONLINE_BANKING: null },
                successData: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_COMPANY_PAYMENT_ONLINE_BANKING:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_PAYMENT_ONLINE_BANKING: null },
                success: { ...state.success, COMPANY_PAYMENT_ONLINE_BANKING: null },
                successData: null,
                error: true,
            }

        case LedgerActionTypes.START_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: true },
            }
        case LedgerActionTypes.SUCCESS_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: null },
                success: { ...state.success, SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: true },
                status: action.payload?.status,
                successData: action.payload?.successData,
                error: null,
            }
        case LedgerActionTypes.FINISH_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: null },
                success: { ...state.success, SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: null },
                successData: null,
                status: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: null },
                success: { ...state.success, SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT: null },
                successData: null,
                status: null,
                error: true,
            }

        case LedgerActionTypes.START_TRANSLITERATION_TRANSFER_REFERENCE:
            return {
                ...state,
                loader: { ...state.loader, TRANSLITERATION_TRANSFER_REFERENCE: true },
            }
        case LedgerActionTypes.SUCCESS_TRANSLITERATION_TRANSFER_REFERENCE:
            return {
                ...state,
                loader: { ...state.loader, TRANSLITERATION_TRANSFER_REFERENCE: null },
                transliteratedReference: action.payload,
                error: null,
            }
        case LedgerActionTypes.FINISH_TRANSLITERATION_TRANSFER_REFERENCE:
            return {
                ...state,
                loader: { ...state.loader, TRANSLITERATION_TRANSFER_REFERENCE: null },
                transliteratedReference: null,
                error: null,
            }
        case LedgerActionTypes.FAILURE_TRANSLITERATION_TRANSFER_REFERENCE:
            return {
                ...state,
                loader: { ...state.loader, TRANSLITERATION_TRANSFER_REFERENCE: null },
                transliteratedReference: null,
                error: true,
            }

        default:
            return state
    }
}

export default leaderReducer
